import React, { useEffect, useState } from "react";
import { IonItem, IonDatetime } from "@ionic/react";
import dayjs from "dayjs";

import "./DateTimePicker.scss";
import { utilService } from "../../../services/utilService";
import { useTranslation } from "react-i18next";

/**
 * Time-picker component
 * Component will show a popup to select hour and minute.
 * Component will return the time in the format 24 hours format.
 */

interface TimePickerProps {
  getSelectedTime: (value: string) => void;
  minValue: any;
  maxValue: any;
  dateTimeValue: any;
}

interface resultFormat {
  ampm: { value: string };
  hour: { value: number };
  minute: { value: number };
  day: { value: number };
  month: { value: number };
  year: { value: number };
}

const DateTimePicker: React.FC<TimePickerProps> = (props) => {
  let currTime = utilService.getCurrentTime();
  const [selectedTime, setSelectedTime] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    if (props.dateTimeValue) {
      const isoTime = dayjs(props.dateTimeValue).format('YYYY-MM-DDTHH:mm:ss');
      setSelectedTime(isoTime);
      props.getSelectedTime(
        dayjs(props.dateTimeValue).format("YYYY-MM-DD HH:mm:ss")
      );
    } else {
      // Initialize with current time if not provided
      const isoTime = dayjs().format('YYYY-MM-DDTHH:mm:ss');
      setSelectedTime(isoTime);
      props.getSelectedTime(
        dayjs().format("YYYY-MM-DD HH:mm:ss")
      );
    }
  }, [props.dateTimeValue]);

  useEffect(() => { }, [selectedTime]);

  const handleChange = (res: any) => {
    props.getSelectedTime(res);
    const result = dayjs(res).format('YYYY-MM-DDTHH:mm:ss');
    setSelectedTime(result);
  };

  return (

    <IonItem>
      <IonDatetime
        display-format="MM/DD/YY, hh:mm A"
        picker-format="MM/DD/YYYY hh:mm A"
        // min="2021-02-21"
        // max="2021-02-22"
        cancelText={t("cancel")}
        doneText="OK"
        value={selectedTime}
        color="aqua"
        onIonChange={(e) => handleChange(e.detail.value!)}
      ></IonDatetime>
    </IonItem>

  );
};

export default DateTimePicker;
